export default {"src":"/_next/static/media/EyeInfectionsandAllergies.627d5a6c.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};